module.exports = __webpack_public_path__ + "static/media/it.b073e901.svg";